import React, { useState } from 'react';
import { authToken } from '../../authToken';
import TimePicker from '../../components/TimePicker';
import { API_BASE_URL } from '../../config';

const ENDPOINT_HOST = API_BASE_URL;
const ENDPOINT_WORKOUT = `${ENDPOINT_HOST}/workout`;

export default function WorkoutAddPanel({ onClose = null }) {
  const [selectedTimestamp, setSelectedTimestamp] = useState(Date.now());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleTimeChange = (timestamp) => {
    setSelectedTimestamp(timestamp);
  };

  const handleCancel = () => {
    setSelectedTimestamp(Date.now());
    setError(null);
    if (onClose) onClose();
  };

  const handleOk = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(ENDPOINT_WORKOUT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(authToken ? { 'Authorization': authToken } : {})
        },
        body: JSON.stringify({
          timestamp: selectedTimestamp
        })
      });

      if (response.ok) {
        if (onClose) onClose();
      } else {
        const errorData = await response.text();
        setError(`Failed to add workout entry: ${errorData} (${response.status})`);
      }
    } catch (e) {
      console.error('Failed to add workout entry:', e);
      setError('Failed to add workout entry. Please check your connection.');
    } finally {
      setTimeout(() => setIsSubmitting(false), 1000);
    }
  };

  const buttonStyle = {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    minWidth: '100px'
  };

  return (
    <div
      style={{
        padding: '10px 0',
        maxWidth: '400px',
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <div>
        <h3 style={{ margin: '0 0 16px 0', textAlign: 'center' }}>
          🏋️ Add Workout
        </h3>

        {error && (
          <div
            style={{
              padding: '12px',
              backgroundColor: '#f8d7da',
              color: '#721c24',
              borderRadius: '8px',
              marginBottom: '16px',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #f5c6cb'
            }}
          >
            ⚠️ {error}
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '16px'
          }}
        >
          <TimePicker initialTimestamp={selectedTimestamp} onTimeChange={handleTimeChange} />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          marginTop: 'auto'
        }}
      >
        <button
          onClick={handleCancel}
          disabled={isSubmitting}
          style={{
            ...buttonStyle,
            backgroundColor: '#6c757d',
            color: 'white',
            opacity: isSubmitting ? 0.6 : 1
          }}
          onMouseOver={(e) => !isSubmitting && (e.target.style.backgroundColor = '#5a6268')}
          onMouseOut={(e) => !isSubmitting && (e.target.style.backgroundColor = '#6c757d')}
        >
          Cancel
        </button>
        <button
          onClick={handleOk}
          disabled={isSubmitting}
          style={{
            ...buttonStyle,
            backgroundColor: '#f6e96b',
            color: '#333',
            opacity: isSubmitting ? 0.6 : 1
          }}
          onMouseOver={(e) => !isSubmitting && (e.target.style.backgroundColor = '#f4e456')}
          onMouseOut={(e) => !isSubmitting && (e.target.style.backgroundColor = '#f6e96b')}
        >
          {isSubmitting ? 'Adding...' : 'OK'}
        </button>
      </div>
    </div>
  );
}
